if (document.getElementById('page-secret')) {
  pageSecret()
}
function pageSecret() {
  //  ######   #####    ####     ####    ##      #####
  //    ##    ##   ##  ##       ##       ##      ##
  //    ##    ##   ##  ##  ###  ##  ###  ##      #####
  //    ##    ##   ##  ##   ##  ##   ##  ##      ##
  //    ##     #####    ####     ####    ######  #####

  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-toggle')) {
      return
    }
    // 切り替え対象を取得
    const itemList = document.getElementsByClassName('js-toggle-item')
    // アクティブにする対象を取得
    const target = 'js-toggle-item--' + e.target.dataset.toggle
    for (const iterator of itemList) {
      if (iterator.classList.contains(target)) {
        iterator.classList.add('active')
      } else {
        iterator.classList.remove('active')
      }
    }
  })

  //  #####     ###     ####   ####
  //  ##  ##   ## ##   ##     ##
  //  #####   ##   ##   ###    ###
  //  ##      #######     ##     ##
  //  ##      ##   ##  ####   ####

  // パスワード入力で秘密対談ページに入る処理

  /* global hUrl */

  const passInput = document.querySelector('.js-pass-input')
  const passError = document.querySelector('.js-pass-error')

  // 送信ボタンクリックか入力欄のEnterで起動
  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-pass')) {
      return
    }
    passAuth()
  })
  passInput.addEventListener('keypress', function (e) {
    if (e.keyCode !== 13) {
      return false
    }
    passAuth()
  })

  function passAuth() {
    let inputText = passInput.value

    inputText = inputText.trim() // 前後の空白文字を除去
    inputText = zen2han(inputText) // 半角変換

    if (inputText === '31912') {
      passError.classList.remove('active')
      window.location.href = hUrl + 'secret-talk/'
    } else {
      passError.classList.add('active')
    }
  }

  // 全角英数字を半角英数字に変換
  function zen2han(text) {
    return text.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xfee0)
    })
  }
}
